import { Client } from "@xmpp/client"
import { getAllItemsBatched, getItemsByIDs } from "./PubSub"
import { wizardJid } from "@/jidUtils"
import XmppPubSubApi from "../xmppPubSubApi"
import { Route2g } from "@/reducers/routes2gSlice"
import Route2gParser from "@/lib/route2gParser"
import { Element } from "@xmpp/xml"

const NODE = "urn:slickshift:route:0"

const routeFromItem = (item: Element): Route2g | undefined => {
  const routeElement = item.getChild("route", NODE)
  if (!routeElement) return undefined
  return {
    jid: item.attrs.id,
    stops: Route2gParser.parseRouteStops(routeElement) || [],
    pastStops: Route2gParser.parsePastStops(routeElement),
    lastUpdatedBy: routeElement.getAttr("last_updated_by"),
  }
}

export const retrieveDriverRoute = async (
  xmpp: Client,
  driverJid: string,
): Promise<Route2g | undefined> => {
  const response = await getItemsByIDs({
    xmpp,
    jid: wizardJid(xmpp.jid!),
    node: NODE,
    ids: [driverJid],
    timeout: 4000,
  })
  const item = response
    .getChild("pubsub")
    ?.getChild("items")
    ?.getChildren("item")
    .find((candidate) => candidate.attrs.id === driverJid)
  return item ? routeFromItem(item) : undefined
}

export const retrieveAllDriverRoutes = async (
  xmpp: Client,
): Promise<Array<Route2g | undefined>> => {
  const items = await getAllItemsBatched({
    xmpp,
    jid: wizardJid(xmpp.jid!),
    node: NODE,
    timeout: 4000,
  })

  return items.map(routeFromItem)
}

export const subscribeToRoutes = async (client: Client) => {
  try {
    await XmppPubSubApi.subscribe(window.XMPP!, wizardJid(client.jid!), NODE)
  } catch (error: any) {
    if (error.condition !== "item-not-found") {
      console.warn(`Error subscribing to ${NODE}`, error)
    }
  }
}
